/*
   vueuse local storage has some strange, buggy side-effects,
   so were re-implementing just the parts we need here
*/
import { ref, watch } from "vue";
import { match } from "@/utils/utils";
function stringify(value) {
    if (typeof value !== "object") {
        return `${value}`;
    }
    else {
        return JSON.stringify(value);
    }
}
function parse(value, type) {
    return match(type, {
        string: () => value,
        number: () => parseFloat(value),
        boolean: () => (value.toLowerCase().trim() === "true" ? true : false),
        object: () => JSON.parse(value),
    });
}
export function syncRefToLocalStorage(key, refToSync) {
    const stored = window.localStorage.getItem(key);
    const sync = () => {
        const stringified = stringify(refToSync.value);
        window.localStorage.setItem(key, stringified);
    };
    if (stored !== null) {
        try {
            refToSync.value = parse(stored, typeof refToSync.value);
        }
        catch (e) {
            console.error(`Failed to parse value "${stored}" from local storage key "${key}". Resetting key`);
            sync();
        }
    }
    else {
        sync();
    }
    watch(() => refToSync.value, () => {
        sync();
    }, { deep: true });
}
export function usePersistentRef(key, defaultValue) {
    const storageSyncedRef = ref(defaultValue);
    syncRefToLocalStorage(key, storageSyncedRef);
    return storageSyncedRef;
}
